/** The numbers behind the KPIs a page shows. A page (cockpit, Bank, results, preview) provides them; a KPI popover reads its own formula's inputs from here. */
import { createContext, useContext } from "react";
import type { KpiId } from "@bsim/domain";
import { computedFor, type Computed, type KpiInputsView } from "../format/formulas";

const KpiInputsContext = createContext<KpiInputsView | null>(null);
export const KpiInputsProvider = KpiInputsContext.Provider;

/** A period's inputs as a page provides them: a released period covers one month; absent inputs (an older pack) provide nothing. */
export const periodInputsView = (inputs: KpiInputsView["inputs"] | undefined, kpis: KpiInputsView["kpis"]): KpiInputsView | null =>
  inputs === undefined ? null : { inputs, months: 1, ...(kpis === undefined ? {} : { kpis }) };

/** The formula for `kpi` with the page's numbers; none when the page provides none or the KPI has no template. */
export function useKpiComputed(kpi: KpiId | undefined): Computed | undefined {
  const view = useContext(KpiInputsContext);
  return kpi === undefined || view === null ? undefined : computedFor(kpi, view);
}
